<form [formGroup]="voiceFormGroup">
  <div class="row m-tb-15">
    <div class="col-6">
      <mat-form-field class="full-width">
        <mat-label>Voice Name</mat-label>
        <input matInput placeholder="Voice Name" formControlName="name" />
      </mat-form-field>
    </div>
  </div>
</form>

<div *ngIf="previewURL" class="d-flex justify-content-center">
  <audio class="audioCenter" controls>
    <source src="{{ previewURL }}" type="audio/mp3" />
    Your browser does not support the audio tag.
  </audio>
</div>

<app-upload
  [isUploading]="uploading$ | async"
  (filetoUpload)="upload($event)"
></app-upload>
